query SocialMediaPostingStatus($postingOperationId: ID!) {
  result: socialMediaPostingStatus(postingOperationId: $postingOperationId) {
    status
    total
    completed
    failed
    platforms {
      platform
      status
      hasFailed
      permalink
      failureReason
    }
  }
}
